import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { aboutimg } from "../Constant/Index";
import { contentApi } from "../network/Network";

const Services = () => {
  let currentUrl = window.location.href.split("/");
  const [getapi, setGetapi] = useState("");

  // how it work on
  useEffect(() => {
    contentApi(currentUrl[3])
      .then((res) => {
        setGetapi(res?.data);
      })
      .catch((err) => {});
  }, []);
  // ==================
  return (
    <>
      <Header />
      <PageHeader pagename="Services" />
      <section className="how-it-work Services">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 ">
              <div className="solve-detail-img ">
                <div className="row ">
                  <div className="col-lg-6 position-relative">
                    <div className="how-it-work-img">
                      <figure>
                        <img src={getapi?.sectionOne?.image} className="img-fluid " alt="" />
                      </figure>
                    </div>
                  </div>
                  <div className="col-lg-6 mt-5 ps-0">
                    <div className="solved-heading pe-4">
                      <h3 className="main-heading-font dark-color level-2 wow animate__ animate__zoomIn animated">
                        {getapi?.sectionOne?.heading}
                      </h3>
                      <p
                        className="primary-regular-font extra-color-5 level-7"
                        dangerouslySetInnerHTML={{
                          __html: getapi?.sectionOne?.paragraph,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className=" key-features mt-5 mb-5 pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mx-auto">
              <div className="row extra-bg-8 radius-20 p-5 position-relative">
                <div className="col-lg-12">
                  <div className="row">
                    <div className="col-lg-12">
                      <h2 className="main-heading-font text-center dark-color extra-color-5  level-2 ">
                        {getapi?.sectionTwo?.heading}
                      </h2>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-lg-4">
                      <div className="text-center ng radius-20 p-4 dark-bg">
                        <h4 className="text-white main-heading-font level-3">
                          {getapi?.sectionTwo?.sub_heading_1}
                        </h4>
                        <p
                          className="text-white"
                          dangerouslySetInnerHTML={{
                            __html: getapi?.sectionTwo?.paragraph_1,
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="text-center ng radius-20 p-4 dark-bg">
                        <h4 className="text-white main-heading-font level-3">
                          {getapi?.sectionTwo?.sub_heading_2}
                        </h4>
                        <p
                          className="text-white"
                          dangerouslySetInnerHTML={{
                            __html: getapi?.sectionTwo?.paragraph_2,
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="text-center ng radius-20 p-4 dark-bg">
                        <h4 className="text-white main-heading-font level-3">
                          {getapi?.sectionTwo?.sub_heading_3}
                        </h4>
                        <p
                          className="text-white"
                          dangerouslySetInnerHTML={{
                            __html: getapi?.sectionTwo?.paragraph_3,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Services;
